
import React from 'react';
import { Link2 } from 'lucide-react';

export const LinkIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <Link2 strokeWidth={1.5} {...props} />
);
